import React, { useMemo } from 'react'

import { useOperatorData } from '@contexts/operator/OperatorDataContext'
import { useIsStandard } from '@contexts/operator/PlanContext'
import ImportsList from '@shared/imports/ImportsList'
import ListPageHeader from '@shared/ListPageHeader'

import { importService } from '@services/operator/importService'

export default function OperatorImportsList() {
  const { merchants } = useOperatorData()
  const isStandard = useIsStandard()

  const merchantOptions = useMemo(() => {
    return merchants.map(merchant => ({
      label: merchant.name,
      value: merchant.id
    }))
  }, [merchants])

  return (
    <div>
      <ListPageHeader items={['integration_logs', 'integration_logs.imports']} />
      <ImportsList
        role="operator"
        service={importService}
        merchants={merchantOptions}
        hideMerchantUI={isStandard}
      />
    </div>
  )
}
